import {useState, useRef} from 'react'
import {startOfDay} from 'date-fns'

import {DropdownIcon, ArrowIcon} from 'common/components'
import {AntdDatePicker} from './DatePicker'
import {DATE_PATTERN, MIN_PICKER_DATE} from 'common/constants'

const {RangePicker: AntdRangePicker} = AntdDatePicker

const placeholder = ['Open date', 'Maturity date']

export default function RangePicker({disablePast, ...props}: any) {
  const [isOpen, setIsOpen] = useState(false)
  const minDateRef = useRef(
    disablePast ? startOfDay(new Date()) : MIN_PICKER_DATE
  )

  const disabledDate = (date: Date) => date < minDateRef.current

  return (
    <AntdRangePicker
      format={isOpen ? DATE_PATTERN.pickerShort : DATE_PATTERN.pickerLong}
      suffixIcon={<DropdownIcon />}
      separator={<ArrowIcon />}
      placeholder={placeholder}
      disabledDate={disabledDate}
      onOpenChange={setIsOpen}
      {...props}
    />
  )
}
